var render, staticRenderFns
import script from "./OnClickOutside.vue?vue&type=script&lang=js&"
export * from "./OnClickOutside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a37ce402')) {
      api.createRecord('a37ce402', component.options)
    } else {
      api.reload('a37ce402', component.options)
    }
    
  }
}
component.options.__file = "www/vue_components/desktop/core/OnClickOutside.vue"
export default component.exports